import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class AuthLayoutComponent {}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/layouts/auth/auth-layout.component.ts